export const TECHNICIAN_UNAVAILABLE_PAGE='TECHNICIAN_UNAVAILABLE_PAGE';
export const TECHNICIAN_AVAILABLE_PAGE='TECHNICIAN_AVAILABLE_PAGE';
